module.exports = __webpack_public_path__ + "static/media/renaissance.64a75300.png";